// extracted by mini-css-extract-plugin
export var askAiIcon = "_pw-9";
export var container = "_pw-0";
export var groupSeparator = "_pw-a";
export var highlight = "_pw-4";
export var resultIcon = "_pw-5";
export var resultItem = "_pw-7";
export var resultSubtitle = "_pw-3";
export var resultTitle = "_pw-2";
export var resultsList = "_pw-1";
export var searchGroup = "_pw-6";
export var selected = "_pw-8";